
const Values = () => {
  const values = [
    {
      icon: 'ri-heart-line',
      title: 'Integrity',
      description: 'We operate with transparency, honesty, and ethical practices in all our interactions.',
      color: 'bg-red-50 text-red-600'
    },
    {
      icon: 'ri-team-line',
      title: 'Cooperation',
      description: 'We believe in the power of working together to achieve common goals and mutual success.',
      color: 'bg-blue-50 text-blue-600'
    },
    {
      icon: 'ri-scales-line',
      title: 'Equity',
      description: 'We ensure fair access to financial services regardless of background or circumstances.',
      color: 'bg-green-50 text-green-600'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Responsibility',
      description: 'We take responsibility for our community\'s financial well-being and sustainable growth.',
      color: 'bg-purple-50 text-purple-600'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'We continuously improve our services to meet the evolving needs of our diverse community.',
      color: 'bg-orange-50 text-orange-600'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Compassion',
      description: 'We understand the unique challenges faced by newcomers and provide supportive solutions.',
      color: 'bg-teal-50 text-teal-600'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Core Values
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            These fundamental principles guide every decision we make and every service we provide
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow">
              <div className={`w-12 h-12 ${value.color} rounded-lg flex items-center justify-center mb-4`}>
                <i className={`${value.icon} text-xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
              <p className="text-gray-600">{value.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-teal-600 rounded-xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">
            Join Our Cooperative Community
          </h3>
          <p className="text-teal-100 mb-6 max-w-2xl mx-auto">
            Become part of a financial institution that truly understands and serves the needs of Calgary's 
            diverse community. Together, we can build a stronger financial future.
          </p>
          <button className="bg-white text-teal-600 hover:bg-gray-100 px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer">
            Registration to become a member is coming soon
          </button>
        </div>
      </div>
    </section>
  );
};

export default Values;
